module.exports = "/static/assets/5fdb7c093bfefc2c00ef83fd4c34199e.gif";